module.exports = __webpack_public_path__ + "img/know.png";